module.exports = __webpack_public_path__ + "img/party.d65d7d14.png";